import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "SurveysList",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getSurveysList, getSurveysListError, getSurveysListSuccess } =
  slice.actions;

reducerRegistry.register("surveysList", reducer);
